import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    selectedEquivalentStation: {},
    equivalentStations: [],
  }),

  mutations: {
    setSelectedEquivalentStation(state, equivalentStation) {
      Vue.set(state, "selectedEquivalentStation", equivalentStation);
    },
    setEquivalentStations(state, equivalentStations) {
      Vue.set(state, "equivalentStations", equivalentStations);
    },
    setDefaultEquivalentStationModule(state, equivalentStations) {
      Vue.set(state, "selectedEquivalentStation", {});
      Vue.set(state, "equivalentStations", []);
    },
  },

  actions: {
    //TODO: load, update, create
    createEquivalentStation: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/equivalent-stations/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadPublishedEquivalentStations: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/equivalent-stations/entity/published").then((response) => {
        return response.data;
      });
    },

    loadEquivalentStation: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/equivalent-stations/entity/" + request.id).then((response) => {
        return response.data;
      });
    },

    loadEquivalentStations: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/equivalent-stations/entity").then((response) => {
        context.commit("setEquivalentStations", response.data);
        return response.data;
      });
    },

    loadSelectedEquivalentStationHistory: (context, equivalentStation) => {
      return axios.get(context.getters.getMcServiceUrl + "/equivalent-stations/history/" + equivalentStation.id, {}).then((response) => {
        return response.data;
      });
    },

    deleteEquivalentStation: (context, equivalentStation) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/equivalent-stations/entity/" + equivalentStation.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          equivalentStation.intents = intents;
          equivalentStation.intentId = response.data.id;
          return equivalentStation;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftEquivalentStation: (context, equivalentStation) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/equivalent-stations/draft/" + equivalentStation.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishEquivalentStation: (context, equivalentStation) => {
      return axios.get(context.getters.getMcServiceUrl + "/equivalent-stations/publish/" + equivalentStation.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },
    rejectEquivalentStation: (context, equivalentStation) => {
      return axios.get(context.getters.getMcServiceUrl + "/equivalent-stations/reject/" + equivalentStation.intentId).then((response) => {
        helper.recallOrRejectEntity(equivalentStation, "station_status");
        return response.data;
      });
    },
    sendToApprovalEquivalentStations: (context, equivalentStation) => {
      return axios.get(context.getters.getMcServiceUrl + "/equivalent-stations/sendToApproval/" + equivalentStation.intentId).then((response) => {
        if (equivalentStation.intents[0].type === "CREATE_STATION_STATUS") {
          equivalentStation.intents[0].status = "WAITING_APPROVAL";
        } else if (equivalentStation.intents[0].type === "UPDATE_STATION_STATUS") {
          equivalentStation.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },
    recallEquivalentStation: (context, equivalentStation) => {
      return axios.get(context.getters.getMcServiceUrl + "/equivalent-stations/recall/" + equivalentStation.intentId).then((response) => {
        helper.recallOrRejectEntity(equivalentStation, "station_status");
        return response.data;
      });
    },
    cancelEquivalentStation: (context, equivalentStation) => {
      return axios.get(context.getters.getMcServiceUrl + "/equivalent-stations/cancel/" + equivalentStation.intentId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getSelectedEquivalentStation: (state) => {
      return state.selectedEquivalentStation;
    },
    getEquivalentStations: (state) => {
      return state.equivalentStations;
    },
    getPublishedEquivalentStations: (state) => {
      return state.equivalentStations.filter((entity) => {
        return entity.intentId === 0;
      });
    },
  },
};
